import React from "react";
import { Typography } from "@mui/material";

const SubText = ({ text }) => {
  return (
    <Typography
      sx={{
        fontSize: { xs: "20px", md: "5vw", lg: "60px" },
        color: "#09507F",
        whiteSpace: "wrap",
        marginBottom: { xs: "10%", sm: "10%", md: "6%", lg: "2%" },
      }}
      align="center"
      variant="body2"
      padding={{ xs: "0 10%", sm: "0 10%", md: "0 10%", lg: "0 5%" }}
    >
      <div dangerouslySetInnerHTML={{ __html: text }}></div>
    </Typography>
  );
};

export default SubText;
